const LandingPage = ({ size = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-id="treeNode_landingpages_18AssetIcon"
    className="spectrum-Icon_368b34 spectrum-Icon--sizeS_368b34 TreeIconWrapper spectrum-Icon_e2d99e"
    focusable="false"
    aria-hidden="true"
    role="img"
    width={size}
    height={size}
    fill={'rgb(105, 123, 144)'}
  >
    <defs>
      <symbol id="icon-meue-landing-page" viewBox="0 0 20 20">
        <path
          d="M19.375 18.75H.625A.626.626 0 010 18.125V1.875a.626.626 0 01.625-.625h18.75a.626.626 0 01.625.625v16.25a.626.626 0 01-.625.625zM7.027 11.564l1.364.472a2.173 2.173 0 00.33.086l1.044.184-2.1 4.313.416.074a.487.487 0 00.088.008.5.5 0 00.389-.184l3.209-3.858 2.264.4a2.439 2.439 0 00.421.037 2.411 2.411 0 00.986-.209l.155-.068a.3.3 0 00.175-.224.3.3 0 00-.088-.271l-.121-.118a2.424 2.424 0 00-1.263-.643l-2.265-.4-1.7-4.723a.507.507 0 00-.389-.328l-.416-.074.5 4.772-1.044-.185a2.164 2.164 0 00-.339-.032l-1.445-.022-1.139-1.793-.353-.062.191 1.834-.874-.014a.164.164 0 00-.162.134.162.162 0 00.107.182l.825.285-.807 1.66.353.062 1.684-1.295zM1.25 2.75V4.5h17.5V2.75z"
          data-name="Landing Page"
        ></path>
      </symbol>
    </defs>
    <use xlinkHref="#icon-meue-landing-page" fill="#697B90"></use>
  </svg>
);

export default LandingPage;
